import { render, staticRenderFns } from "./diacritics.vue?vue&type=template&id=0ae4d7a5&"
import script from "./diacritics.vue?vue&type=script&lang=js&"
export * from "./diacritics.vue?vue&type=script&lang=js&"
import style0 from "./diacritics.vue?vue&type=style&index=0&id=0ae4d7a5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports